module.exports = __webpack_public_path__ + "img/bold.fc4a1902.svg";